import { render, staticRenderFns } from "./Vidjet-header.vue?vue&type=template&id=6790870b&"
import script from "./Vidjet-header.vue?vue&type=script&lang=js&"
export * from "./Vidjet-header.vue?vue&type=script&lang=js&"
import style0 from "./Vidjet-header.vue?vue&type=style&index=0&id=6790870b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports